//
//
//
//
//
//

export default {
    name: 'LoadingComponent'
}
